(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-khloud"] && !Shopify.designMode) return;
  try {
    
  class KhloudBestsellersCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.khloud-bestsellers__viewport');
      this.track = this.querySelector('.khloud-bestsellers__track');
      this.prevBtn = this.closest('.khloud-bestsellers').querySelector('[data-khloud-bs-prev]');
      this.nextBtn = this.closest('.khloud-bestsellers').querySelector('[data-khloud-bs-next]');
      this.dotsWrap = this.querySelector('[data-khloud-bs-dots]');
      if (!this.viewport || !this.track) return;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.page(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.page(1));
      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.buildDots());
      this.resizeObserver.observe(this.viewport);
      this.buildDots();
    }

    disconnectedCallback() { this.resizeObserver && this.resizeObserver.disconnect(); }

    page(direction) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollBy({ left: direction * this.viewport.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    buildDots() {
      if (!this.viewport.clientWidth) return;
      const pageCount = Math.max(1, Math.round(this.track.scrollWidth / this.viewport.clientWidth));
      const hasOverflow = this.track.scrollWidth > this.viewport.clientWidth + 4;

      if (this.prevBtn) this.prevBtn.disabled = !hasOverflow;
      if (this.nextBtn) this.nextBtn.disabled = !hasOverflow;

      if (this.pageCount === pageCount) { this.updateActiveDot(); return; }
      this.pageCount = pageCount;
      if (!this.dotsWrap) return;

      this.dotsWrap.innerHTML = '';
      if (pageCount <= 1) { this.dotsWrap.hidden = true; return; }
      this.dotsWrap.hidden = false;

      for (let i = 0; i < pageCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'khloud-bestsellers__dot';
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.addEventListener('click', () => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.viewport.scrollTo({ left: i * this.viewport.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
        this.dotsWrap.appendChild(dot);
      }
      this.updateActiveDot();
    }

    onScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => { this.scrollRaf = null; this.updateActiveDot(); });
    }

    updateActiveDot() {
      if (!this.dotsWrap) return;
      const dots = this.dotsWrap.querySelectorAll('.khloud-bestsellers__dot');
      if (!dots.length) return;
      const index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      dots.forEach((dot, i) => dot.classList.toggle('khloud-bestsellers__dot--active', i === index));
    }
  }
  customElements.define('khloud-bestsellers-carousel', KhloudBestsellersCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-strip-khloud"] && !Shopify.designMode) return;
  try {
    
  class KhloudBrandsCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.khloud-brands__viewport');
      this.track = this.querySelector('.khloud-brands__track');
      this.prevBtn = this.querySelector('[data-khloud-brands-prev]');
      this.nextBtn = this.querySelector('[data-khloud-brands-next]');
      this.dotsWrap = this.querySelector('[data-khloud-brands-dots]');
      if (!this.viewport || !this.track) return;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.page(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.page(1));
      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.buildDots());
      this.resizeObserver.observe(this.viewport);
      this.buildDots();
    }

    disconnectedCallback() { this.resizeObserver && this.resizeObserver.disconnect(); }

    page(direction) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollBy({ left: direction * this.viewport.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    buildDots() {
      if (!this.viewport.clientWidth) return;
      const pageCount = Math.max(1, Math.round(this.track.scrollWidth / this.viewport.clientWidth));
      const hasOverflow = this.track.scrollWidth > this.viewport.clientWidth + 4;

      if (this.prevBtn) this.prevBtn.disabled = !hasOverflow;
      if (this.nextBtn) this.nextBtn.disabled = !hasOverflow;
      if (!hasOverflow) {
        if (this.prevBtn) this.prevBtn.hidden = true;
        if (this.nextBtn) this.nextBtn.hidden = true;
      } else {
        if (this.prevBtn) this.prevBtn.hidden = false;
        if (this.nextBtn) this.nextBtn.hidden = false;
      }

      if (this.pageCount === pageCount) { this.updateActiveDot(); return; }
      this.pageCount = pageCount;
      if (!this.dotsWrap) return;

      this.dotsWrap.innerHTML = '';
      if (pageCount <= 1) { this.dotsWrap.hidden = true; return; }
      this.dotsWrap.hidden = false;

      for (let i = 0; i < pageCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'khloud-brands__dot';
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.addEventListener('click', () => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.viewport.scrollTo({ left: i * this.viewport.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
        this.dotsWrap.appendChild(dot);
      }
      this.updateActiveDot();
    }

    onScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => { this.scrollRaf = null; this.updateActiveDot(); });
    }

    updateActiveDot() {
      if (!this.dotsWrap) return;
      const dots = this.dotsWrap.querySelectorAll('.khloud-brands__dot');
      if (!dots.length) return;
      const index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      dots.forEach((dot, i) => dot.classList.toggle('khloud-brands__dot--active', i === index));
    }
  }
  customElements.define('khloud-brands-carousel', KhloudBrandsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-khloud"] && !Shopify.designMode) return;
  try {
    
  class KhloudHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.khloud-hero__slide'));
      if (this.slides.length <= 1) return;

      this.dots = Array.from(this.querySelectorAll('[data-khloud-dot]'));
      this.prevBtn = this.querySelector('[data-khloud-prev]');
      this.nextBtn = this.querySelector('[data-khloud-next]');
      this.current = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1, true));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1, true));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.khloudDot, 10), true));
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.current - 1, true);
        if (event.key === 'ArrowRight') this.go(this.current + 1, true);
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      this.setupSwipe();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    go(index, userInitiated) {
      const next = (index + this.slides.length) % this.slides.length;
      if (next === this.current) return;

      this.slides[this.current].classList.remove('khloud-hero__slide--active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.slides[next].classList.add('khloud-hero__slide--active');
      this.slides[next].removeAttribute('aria-hidden');

      if (this.dots.length) {
        this.dots[this.current].classList.remove('khloud-hero__dot--active');
        this.dots[this.current].setAttribute('aria-selected', 'false');
        this.dots[next].classList.add('khloud-hero__dot--active');
        this.dots[next].setAttribute('aria-selected', 'true');
      }

      this.current = next;
      if (userInitiated) this.restartAutoplay();
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.timer) return;
      this.timer = window.setInterval(() => this.go(this.current + 1, false), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    setupSwipe() {
      let startX = 0;
      let tracking = false;
      const viewport = this.querySelector('.khloud-hero__viewport');
      if (!viewport) return;

      viewport.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
        tracking = true;
      }, { passive: true });

      viewport.addEventListener('touchend', (event) => {
        if (!tracking) return;
        tracking = false;
        const deltaX = event.changedTouches[0].clientX - startX;
        if (Math.abs(deltaX) < 40) return;
        if (deltaX < 0) this.go(this.current + 1, true);
        else this.go(this.current - 1, true);
      }, { passive: true });
    }
  }

  customElements.define('khloud-hero-slider', KhloudHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals-khloud"] && !Shopify.designMode) return;
  try {
    
  class KhloudNewArrCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.khloud-newarr__viewport');
      this.track = this.querySelector('.khloud-newarr__track');
      this.prevBtn = this.closest('.khloud-newarr').querySelector('[data-khloud-newarr-prev]');
      this.nextBtn = this.closest('.khloud-newarr').querySelector('[data-khloud-newarr-next]');
      this.dotsWrap = this.querySelector('[data-khloud-newarr-dots]');
      if (!this.viewport || !this.track) return;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.page(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.page(1));
      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.buildDots());
      this.resizeObserver.observe(this.viewport);
      this.buildDots();
    }

    disconnectedCallback() { this.resizeObserver && this.resizeObserver.disconnect(); }

    page(direction) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollBy({ left: direction * this.viewport.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    buildDots() {
      if (!this.viewport.clientWidth) return;
      const pageCount = Math.max(1, Math.round(this.track.scrollWidth / this.viewport.clientWidth));
      const hasOverflow = this.track.scrollWidth > this.viewport.clientWidth + 4;

      if (this.prevBtn) this.prevBtn.disabled = !hasOverflow;
      if (this.nextBtn) this.nextBtn.disabled = !hasOverflow;

      if (this.pageCount === pageCount) { this.updateActiveDot(); return; }
      this.pageCount = pageCount;
      if (!this.dotsWrap) return;

      this.dotsWrap.innerHTML = '';
      if (pageCount <= 1) { this.dotsWrap.hidden = true; return; }
      this.dotsWrap.hidden = false;

      for (let i = 0; i < pageCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'khloud-newarr__dot';
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.addEventListener('click', () => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.viewport.scrollTo({ left: i * this.viewport.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
        this.dotsWrap.appendChild(dot);
      }
      this.updateActiveDot();
    }

    onScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => { this.scrollRaf = null; this.updateActiveDot(); });
    }

    updateActiveDot() {
      if (!this.dotsWrap) return;
      const dots = this.dotsWrap.querySelectorAll('.khloud-newarr__dot');
      if (!dots.length) return;
      const index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      dots.forEach((dot, i) => dot.classList.toggle('khloud-newarr__dot--active', i === index));
    }
  }
  customElements.define('khloud-newarr-carousel', KhloudNewArrCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup-khloud"] && !Shopify.designMode) return;
  try {
    
  class KhloudWelcomePopup extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'khloud_welcome_popup';
      this.force =
        this.querySelector('[data-khloud-welcome-force]')?.dataset.khloudWelcomeForce === 'true' ||
        this.dataset.designMode === 'true';
      const succeeded = !!this.querySelector('[data-khloud-welcome-success]');

      this.querySelectorAll('[data-khloud-welcome-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      const copyBtn = this.querySelector('[data-khloud-welcome-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', () => {
          const code = this.querySelector('[data-khloud-welcome-code] span')?.textContent.trim();
          if (!code) return;
          const done = () => {
            copyBtn.textContent = copyBtn.dataset.labelCopied || 'Copied';
          };
          if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
          else done();
        });
      }

      if (succeeded) {
        this.remember(3650);
        this.open();
        return;
      }

      if (this.force) {
        this.open();
        return;
      }

      if (this.isSuppressed()) return;
      const delay = parseInt(this.dataset.delay, 10) || 0;
      window.setTimeout(() => this.open(), delay);
    }

    open() {
      this.hidden = false;
      this.previousFocus = document.activeElement;
      const target = this.querySelector('input[type="email"], .khloud-welcome__btn');
      if (target) target.focus({ preventScroll: true });
    }

    close() {
      this.hidden = true;
      if (this.dataset.designMode !== 'true') {
        this.remember(parseInt(this.dataset.suppressDays, 10) || 7);
      }
      if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus();
    }

    remember(days) {
      try {
        localStorage.setItem(
          this.storageKey,
          String(Date.now() + days * 24 * 60 * 60 * 1000)
        );
      } catch (e) {}
    }

    isSuppressed() {
      try {
        const until = parseInt(localStorage.getItem(this.storageKey), 10);
        return !!until && Date.now() < until;
      } catch (e) {
        return false;
      }
    }
  }

  customElements.define('khloud-welcome-popup', KhloudWelcomePopup);

  } catch(e) { console.error(e); }
})();
})();
